module.exports = __webpack_public_path__ + "static/media/roofTopFront.51e32d37.png";